// Powerlete colour rollover. Hovering or keyboard-focusing a colour swatch previews that
// colour in the gallery (overlays the linked product's image) and updates the "Colour: name"
// line; reverts on mouseout/blur. Click still navigates to that colour's product page. The
// component is option-agnostic, so a future linked-product selector (e.g. Length) can reuse it.
// No dependencies; the overlay is absolutely positioned so there is no layout shift.
class PwColourPreview extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section') || document;
    this.overlay = section.querySelector('.pw-gallery-preview');
    this.nameEl = this.querySelector('[data-pw-colour-name]');
    this.originalName = this.nameEl ? this.nameEl.textContent : '';
    this.swatches = Array.from(this.querySelectorAll('.pw-colour'));
    if (!this.overlay || this.swatches.length === 0) return;

    this._enter = this._enter.bind(this);
    this._leave = this._leave.bind(this);
    for (const sw of this.swatches) {
      sw.addEventListener('mouseenter', this._enter);
      sw.addEventListener('focus', this._enter);
      sw.addEventListener('mouseleave', this._leave);
      sw.addEventListener('blur', this._leave);
    }
  }

  disconnectedCallback() {
    for (const sw of this.swatches || []) {
      sw.removeEventListener('mouseenter', this._enter);
      sw.removeEventListener('focus', this._enter);
      sw.removeEventListener('mouseleave', this._leave);
      sw.removeEventListener('blur', this._leave);
    }
  }

  _enter(event) {
    const sw = event.currentTarget;
    const src = sw.dataset.previewImage;
    if (src) {
      this.overlay.src = src;
      this.overlay.hidden = false;
    }
    const name = sw.dataset.colourName;
    if (this.nameEl && name) this.nameEl.textContent = name;
  }

  _leave() {
    this.overlay.hidden = true;
    this.overlay.removeAttribute('src');
    if (this.nameEl) this.nameEl.textContent = this.originalName;
  }
}

if (!customElements.get('pw-colour-preview')) {
  customElements.define('pw-colour-preview', PwColourPreview);
}
